import { Guard, GuardService } from 'common/components';
import ErrorScene from 'scenes/error/error.scene';
import { routeIsAllowed } from './auth-provider-config';
import { useAuthContext } from './auth.context';

const ProtectedRoute = ({ children }: React.PropsWithChildren) => {
  const { isAuthenticated, userRole } = useAuthContext();

  const guardService: GuardService<unknown> = {
    checkPermissions: () =>
      isAuthenticated || !!userRole || !!routeIsAllowed(userRole, location.pathname),
  };

  return (
    <Guard guardService={guardService} requiredPermissions={false} forbidden={<ErrorScene />}>
      {children}
    </Guard>
  );
};

export default ProtectedRoute;
